angular.module('unergie.main')
.controller('jiraListModalCtrl', ($q, $sce, $scope, $uibModalInstance, myAccounts, NgTableParams, AlertManager, ApiAdmin, AuthService, BoFeaturesService,
  DataAccessVariables, ErrorCatcher, JiraConstants, JiraService) => {
    $scope.myAccounts = myAccounts
    $scope.JiraConstants = JiraConstants
    $scope.newJiraIssue = JiraService.getNewJiraIssueTemplate('PDL')

    $scope.hideCreateNewJira = true
    const allAccountsOption = [{ brand: 'Tous', value: 'ALL' }]

    if (myAccounts.length === 1) {
        $scope.accounts = $scope.myAccounts
        $scope.selected = { account: myAccounts[0] }
    } else {
        $scope.accounts = allAccountsOption.concat(myAccounts)
        $scope.selected = {
            account: $scope.accounts[0],
        }
    }
    $scope.searchDateTooltip = 'Recherche de date avec opérateurs :\n' +
    '"12/09/2017" : le 12 sept\n' +
    '"<12/09/2017" : avant le 12 sept minuit\n' +
    '"<=12/09/2017" : avant le 12 sept inclus\n' +
    '">12/09/2017" : apres le 12 sept minuit\n' +
    '">=12/09/2017" : apres le 12 sept inclus\n'
    $scope.searchPDLTooltip = ''
    $scope.searchTextTooltip = ''
    $scope.jira_status_mapping = $q.defer()
    $scope.request_type_mapping = $q.defer()
    $scope.jiraIssues = null

    $scope.close = $uibModalInstance.dismiss

    $scope.saveJiraIssue = () => {
        $scope.saving = true
        if ($scope.selected.account.value === 'ALL') {
            $scope.errorMsg = 'Choisissez un adhérent pour pouvoir créer la demande !'
            $scope.saving = false
            return
        }
        $scope.errorMsg = ''
        const jiraIssue = {
            summary: $scope.newJiraIssue.summary,
            description: $scope.newJiraIssue.description,
            type: 'Support',
            customfield_10801: $scope.newJiraIssue.prm,
            customfield_10802: $scope.selected.account.customer_id,
            enrichSummary: false,
            brand: $scope.selected.account.brand,
            requestType: $scope.newJiraIssue.requestType,
        }

        return ApiAdmin.createJiraIssue({ projectKey: AuthService.getAuth().organization }, jiraIssue).$promise.then(() => {
            // Save data
            AlertManager.success('Issue JIRA créée')

            // Refresh data
            $scope.reset()
            $scope.renderTable()
        })
        .catch((err) => {
            $scope.jiraIssues.data = null
            console.error(err)
            return AlertManager.error('Une erreur est intervenue lors de l’appel a JIRA', 5000)
        })
        .finally(() => {
            $scope.saving = false
        })
    }

    $scope.reset = () => {
        $scope.newJiraIssue = JiraService.getNewJiraIssueTemplate('PDL')
        $scope.hideCreateNewJira = !$scope.hideCreateNewJira
    }

    const setDropdownFilterMappings = (issues) => {
        $scope.jira_status_mapping.resolve(_.uniqBy([{ id: '', title: 'Tous' }].concat(_.map(issues, (issue) => ({
            id: issue.fields.status.id,
            title: issue.fields.status.statusCategory.name,
        }))), 'id'))
        $scope.request_type_mapping.resolve(_.map($scope.requestTypes, (requestType) => ({
            id: requestType.name,
            title: requestType.name,
        })))
    }

    const refresh = (params) => {
        $scope.refreshing = true
        const customerIds = $scope.selected.account.value === 'ALL' ? _.map(myAccounts, (account) => account.customer_id) : [$scope.selected.account.customer_id]
        const jiraParams = _.assign({}, params)
        jiraParams.filter = () => _.assign({}, { idCustomer: customerIds.join(',') }, params.filter())
        return JiraService.getData(jiraParams, AuthService.getAuth().organization).$promise.then((response) => {
            const result = response.results
            $scope.jiraIssues.total = () => result.total
            const jiraIssuesMap = _.map(result.issues, (issue) => {
                const organization = issue.fields.organizations.length > 0 ? ` @ ${issue.fields.organizations[0].name}` : ''
                return {
                    key: issue.key,
                    created: moment(issue.fields.created).format('DD/MM/YYYY HH:mm'),
                    requestType: issue.fields.requestType && issue.fields.requestType.requestType ?
                                  issue.fields.requestType.requestType.name : '',
                    summary: issue.fields.summary,
                    description: issue.fields.description,
                    status: issue.fields.status.statusCategory.name,
                    initiator: issue.fields.reporter ? `${issue.fields.reporter.displayName}${organization}` : '',
                    idPrm: issue.fields.idPrm,
                }
            })
            setDropdownFilterMappings(result.issues)
            $scope.jiraIssues.data = jiraIssuesMap

            return jiraIssuesMap
        })
        .catch((err) => {
            $scope.jiraIssues.data = null
            console.error(err)
            return AlertManager.error('Une erreur est intervenue lors de l’appel a JIRA', 5000)
        })
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.isDisabled = () => {
        return !$scope.newJiraIssue.summary
    }

    $scope.renderTable = () => {
        $scope.jiraIssues = new NgTableParams({
            count: ($scope.jiraIssues != null ? $scope.jiraIssues.count() : undefined) || 12,
            filter: ($scope.jiraIssues != null ? $scope.jiraIssues.filter() : undefined) || {},
            sorting: ($scope.jiraIssues != null ? $scope.jiraIssues.sorting() : undefined) || { created: 'desc' },
        }, {
            counts: [12, 25, 50, 100],
            getData: refresh,
        })
    }

    $scope.fetchRequestTypes = () => {
        $scope.loadingIssues = true
        return JiraService.getRequestTypes(AuthService.getAuth().organization).then((requestTypes) => {
            $scope.requestTypes = requestTypes
            $scope.jira_type_mapping = requestTypes
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.loadingIssues = false
        })
    }
    $scope.fetchRequestTypes()
    $scope.renderTable()
})
